export const isInteger = function (val) {
  try {
    let int = parseInt(val);
    return Number.isInteger(int);
  } catch (error) {
    return false;
  }
};

export const isEmptyString = function (val) {
  return val.trim().length === 0;
};

export const isEmail = function (email) {
  var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const isUrl = function (url) {
  if (url.indexOf(" ") !== -1 || url.indexOf(".") === -1) {
    return false;
  } else {
    return true;
  }
};

export const getExternalTag = () => {
  return "external:";
};
export const getExternalLink = (location) => {
  return location.LinkTarget
    ? location.LinkTarget.replace(getExternalTag(), "")
    : "";
};
export const isExternalLink = (location) => {
  return location.LinkTarget
    ? location.LinkTarget.startsWith(getExternalTag())
    : false;
};
